// import { find, assign } from 'lodash'
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      tools = _ref.tools;
  return {
    /**
     * @description 登录
     * @param {Object} data 登录携带的信息
     */
    loadGradeList: function loadGradeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/grade/list',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
      });
    },
    saveGrade: function saveGrade(data) {
      return request({
        url: '/grade/save',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
      });
    }
  };
});